import React, { useState } from "react";
import Footer from "../Footer/Footer.js";
import { Helmet } from "react-helmet-async";

import denise from '../../assets/denise.jpg'
import amanda from '../../assets/amanda.jpg'
import heartsmall from '../../assets/heartsmall.png'

const About = (props) => {

    const [ deniseTab, setDeniseTab ] = useState("-active")
    const [ amandaTab, setAmandaTab ] = useState("")

    const [ tabBio, setTabBio ] = useState("-active")
    const [ tabCerts, setTabCerts ] = useState("")

    const toggleInstructor = (e, who) =>{
        e.preventDefault()
        if (who === "denise"){
          setDeniseTab("-active")
          setAmandaTab("")
        } else {
          setDeniseTab("")
          setAmandaTab("-active")
        }
    }

    const toggleTab = (e, which) =>{
        e.preventDefault()
        if (which === "bio"){
          setTabBio("-active")
          setTabCerts("")
        } else {
          setTabBio("")
          setTabCerts("-active")
        }
    }

  return (
    <div className="container-page" id="about">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content="It's A Good Life Fitness" />
        <title>It's A Good Life Fitness | About</title>
        <link rel="canonical" href="https://itsagoodlifefitness.com" />
      </Helmet>
      <h1>Meet Your Instructors</h1>
      <div className="instructors-buttons">
        <button className={`button${deniseTab}`} onClick={(e) => toggleInstructor(e, "denise")}>Denise</button>
        <div className="line"></div>
        <button className={`button${amandaTab}`} onClick={(e) => toggleInstructor(e, "amanda")}>Amanda</button>
      </div>
      <div className={`instructors${deniseTab}`}>
        <div className="tabs-about">
          
            <div className="tabs-buttons">
                <button className={`tab-button${tabBio}`} id="tab-button-bio-denise" onClick={(e)=> toggleTab(e, "bio")}>
                    Bio
                </button>
                <button className={`tab-button${tabCerts}`} id="tab-button-certs-denise" onClick={(e)=> toggleTab(e, "certs")}>
                    Certifications
                </button>
            </div>
            <div className={`tab${tabBio}`}>
                <div className="description">
                    <p>Meet Denise Nowak, our esteemed <b>Founder</b> of It’s A Good Life Fitness and avid workout enthusiast. As a healthy lifestyle advocate and knowledge junkie, Denise wasn’t simply interested in opening just any fitness program. Instead, she has always been determined to create a community welcome to all levels and bodies to help them achieve their unique fitness goals.</p>
                    <p>Constantly looking to better herself, Denise doesn’t just talk the talk - she’s constantly learning, teaching, training, and engaging in relevant certifications, audiobooks, and courses from industry experts to better understand, instruct, and motivate her clients. Don’t believe us? Just take a look at her long list of certifications!</p>
                </div>
                <img src={heartsmall} width="60" height="52" alt="Heart Small" />
            </div>
            <div className={`tab${tabCerts}`}>
                <div className="description">
                  <p className="list-item-1"><span>National Academy of Sports Medicine</span></p>  
                  <p className="list-item-2">Certified Personal Trainer</p>
                  <p className="list-item-3">Fitness Nutrition Specialist</p>
                  <p className="list-item-4">Behavior Change Specialist</p>
                  <p className="list-item-5">Senior Fitness Specialist</p>
                  <p className="list-item-6">Weight Loss Specialist</p>
                  <p className="list-item-7">MMA Conditioning Specialist</p>
                  <p className="list-item-8">Integrated Core Training</p>
                  <br/>
                  <p className="list-item-9"><span>Welcoa Institute for Wellness Studies</span></p>
                  <p className="list-item-10">Welcoa Faculty</p>
                </div>
                <img src={heartsmall} width="60" height="52" alt="Heart Small" />
            </div>
          
        </div>
        <div className={`profile-pic${deniseTab}`}>
            <img src={denise} height="562" width="417" alt="Denise" />
        </div>
      </div>
      {/* Amanda Tab */}
      <div className={`instructors${amandaTab}`}>
        <div className="tabs-about">
          
            <div className="tabs-buttons">
                <button className={`tab-button${tabBio}`} id="tab-button-bio-amanda" onClick={(e)=> toggleTab(e, "bio")}>
                    Bio
                </button>
                <button className={`tab-button${tabCerts}`} id="tab-button-certs-amanda" onClick={(e)=> toggleTab(e, "certs")}>
                    Certifications
                </button>
            </div>
            <div className={`tab${tabBio}`}>
                <div className="description">
                    <p>Amanda is the <b>Registered Dietitian</b> on our It’s a Good Life Fitness team. She
                      has spent the majority of her life enjoying fitness and living a healthy
                      lifestyle so she chose to make a career out of it in order to help others do the
                      same. She also attends FIT Project small group classes and loves working
                      out to improve her fitness and stay healthy.</p>

                      <p>After graduating from her Masters program in 2019, Amanda started
                      working at a hospital as a clinical dietitian where she still currently sees a
                      variety of patients. Amanda loves helping anyone she works with by
                      meeting them where they’re at. She believes in making sustainable diet
                      changes that allow her clients to lead a balanced lifestyle.</p>

                      {/* <p>When Amanda is not at the gym or working, you can find her staying active
                      with her dog, cooking up new recipes in the kitchen, or enjoying time with
                      her friends and family. She is so excited to be apart of this team and looks
                      forward to sharing her knowledge with each of her new clients and helping
                      them achieve their goals.</p> */}
                </div>
                <img src={heartsmall} width="60" height="52" alt="Heart Small" />
            </div>
            <div className={`tab${tabCerts}`}>
                <div className="description" id="amanda-certs">
                  <p className="list-item-1"><span>Eastern Illinois University</span></p>  
                  <p className="list-item-2">Bachelor of Science in Dietetics</p>
                  <br/>
                  <p className="list-item-3"><span>Loyola University Chicago</span></p>
                  <p className="list-item-4">Master of Science in Dietetics</p>
                  <p className="list-item-5">Dietetic Internship</p>
                </div>
                <img src={heartsmall} width="60" height="52" alt="Heart Small" />
            </div>
          
        </div>
        <div className={`profile-pic${amandaTab}`}>
            <img src={amanda} height="562" width="417" alt="Amanda" />
        </div>
      </div>
      <Footer {...props} />
    </div>
  );
};

export default About;
